import { FBUser } from "../auth/User-dsl"

export const saveUserP = (ps,$) => (user:FBUser) => {

    return ps['<users|'].child(user.uid)
            .set({name:user.name, avatar:user.avatar})
}